import type { ReactNode } from "react";

export default function PricingCard({
  name,
  price,
  pricePrefix,
  priceSuffix,
  description,
  features,
  cta,
  highlighted
}: {
  name: string;
  price: string;
  pricePrefix?: string;
  priceSuffix?: string;
  description: string;
  features: string[];
  cta: ReactNode;
  highlighted?: boolean;
}) {
  return (
    <div
      className={`relative flex h-full flex-col rounded-2xl border p-6 transition duration-300 focus-within:ring-2 focus-within:ring-gray-950 focus-within:ring-offset-4 sm:p-8 ${
        highlighted
          ? "border-[#d8ba28] bg-[#fffdf2] text-gray-950 shadow-[0_20px_45px_-30px_rgba(120,90,0,0.35)]"
          : "border-slate-200 bg-white shadow-[0_12px_35px_-26px_rgba(15,23,42,0.45)]"
      } ${highlighted ? "lg:z-10" : ""}`}
    >
      <div className="lg:min-h-8">
        <h3 className="text-xl font-semibold text-gray-950">{name}</h3>
      </div>
      <p
        className={`mt-3 text-sm leading-7 lg:min-h-[5.5rem] ${
          highlighted ? "text-gray-800" : "text-slate-600"
        }`}
      >
        {description}
      </p>
      <div className="mt-6 lg:min-h-[5.5rem]">
        {pricePrefix ? (
          <p className={`mb-1 text-xs font-medium ${highlighted ? "text-gray-700" : "text-slate-500"}`}>
            {pricePrefix}
          </p>
        ) : null}
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <span className="whitespace-nowrap text-[1.75rem] font-semibold leading-tight text-gray-950">
            {price}
          </span>
          {priceSuffix ? (
            <span className={`text-sm ${highlighted ? "text-gray-700" : "text-gray-500"}`}>
              {priceSuffix}
            </span>
          ) : null}
        </div>
      </div>
      <ul className={`mt-6 flex flex-1 flex-col gap-3 text-sm ${highlighted ? "text-gray-800" : "text-slate-600"}`}>
        {features.map((feature) => (
          <li key={feature} className="flex items-start gap-3">
            <span
              className={`mt-1 inline-flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-xs text-gray-950 ${
                highlighted ? "bg-white/80" : "bg-brand"
              }`}
            >
              ✓
            </span>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <div className="mt-auto pt-8">{cta}</div>
    </div>
  );
}
